/*
 * Crush Audio - lecture differee des videos d'ambiance.
 *
 * Les <video data-crush-lazy data-src="..."> ne telechargent rien au chargement
 * de la page : la source n'est attachee qu'a l'approche du viewport, la lecture
 * ne demarre qu'une fois la video visible, et elle est mise en pause des qu'elle
 * sort de l'ecran ou que l'onglet passe en arriere-plan.
 */
(function () {
  if (window.__crushLazyVideo) return;
  window.__crushLazyVideo = true;

  var PRELOAD_MARGIN = '300px 0px';

  // Rien ne doit concurrencer le rendu initial : on n'arme les observateurs
  // qu'une fois la page chargee et le navigateur disponible.
  function whenIdle(callback) {
    function run() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(callback, { timeout: 2000 });
      } else {
        setTimeout(callback, 200);
      }
    }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(video) {
    if (video.dataset.crushBound === '1') return;
    video.dataset.crushBound = '1';

    var src = video.getAttribute('data-src');
    if (!src) return;

    var loaded = false;

    function load() {
      if (loaded) return;
      loaded = true;
      var source = document.createElement('source');
      source.setAttribute('src', src);
      var type = video.getAttribute('data-type');
      if (type) source.setAttribute('type', type);
      video.appendChild(source);
      video.load();
    }

    function play() {
      load();
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    // Pas d'IntersectionObserver (vieux navigateur) : on garde le comportement
    // d'origine plutot que de laisser une video vide.
    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }

    // Mouvement reduit : on charge la video mais on laisse l'utilisateur decider.
    if (reduceMotion) {
      video.setAttribute('controls', '');
      new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            load();
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: PRELOAD_MARGIN }
      ).observe(video);
      return;
    }

    // 1. Telechargement anticipe quand la video approche du viewport.
    var preloader = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          load();
          preloader.unobserve(entry.target);
        });
      },
      { rootMargin: PRELOAD_MARGIN }
    );
    preloader.observe(video);

    // 2. Lecture / pause selon la visibilite reelle.
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play();
          } else if (loaded && !video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.15 }
    ).observe(video);
  }

  function init(root) {
    var scope = root || document;
    whenIdle(function () {
      Array.prototype.forEach.call(scope.querySelectorAll('video[data-crush-lazy]'), attach);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor : les sections sont re-rendues a la volee.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Onglet en arriere-plan : rien ne doit continuer a tourner.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    Array.prototype.forEach.call(document.querySelectorAll('video[data-crush-lazy]'), function (v) {
      if (!v.paused) v.pause();
    });
  });
})();
